define('js/lib/noop',[],function () {
    'use strict';

    return function () {};
});
